import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";

import jwtService from "./jwt.service";

/**
 * Single source of truth for the API base URL
 */
// Prod
export const API_BASE_URL = "https://iranking.segeplan.gob.gt:8081";

// Dev
// export const API_BASE_URL = "http://192.168.6.150:8081";

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_BASE_URL;
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `${JwtService.getToken()}`;

    //] = `${JwtService.getToken()}`;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  /*get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },*/

  get(resource) {

    return Vue.axios.get(`${resource}`).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    console.log(params)
    let user =  jwtService.getUserId();
    params.usuarioCreacion = user;
    params.usuarioActualizacion = user;
    return Vue.axios.post(`${resource}`,{Data: params}).catch(error => {
       console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });;
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
 /* update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },*/

  update(resource, params) {
    let user =  jwtService.getUserId();
    params.usuarioActualizacion = user;
    params.usuarioCreacion = user;
    return Vue.axios.post(`${resource}`, {Data:params}).catch(error => {
      console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });;
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    let user =  jwtService.getUserId();
    params.usuarioActualizacion = user;
    params.usuarioCreacion = user;
    return Vue.axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },


  /**
   * Almacenar documentos HTTP request
   * @param resource
   * @param document
   */
  uploadFile(resource, file, path){
    let formData = new FormData();

    formData.append('Files', file);
    formData.append('path', path);
    //console.log(file)
 
    let config = {
      headers: {
        "Content-Type": undefined
      }
    };


    return Vue.axios.post(resource, formData, config
      ).catch(error=>{
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;
